export default __webpack_public_path__ + "resources/icons/n440-4d78.png";